import { useEffect, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  'shougong-huangyou-ru-men-zhi-nan': 'https://readdy.ai/api/search-image?query=Artisan%20handmade%20butter%20food%20photography%20on%20rustic%20wooden%20surface%2C%20warm%20golden%20lighting%2C%20cream%20texture%2C%20minimal%20composition%2C%20editorial%20style%2C%20soft%20natural%20light%2C%20elegant%20gourmet%20aesthetic&width=800&height=520&seq=butter-guide-01&orientation=landscape',
  'fa-jiao-huang-you-shen-du-jie-xi': 'https://readdy.ai/api/search-image?query=Artisan%20cultured%20butter%20on%20ceramic%20plate%20with%20fresh%20herbs%2C%20warm%20kitchen%20lighting%2C%20rustic%20wooden%20table%2C%20cream%20and%20golden%20textures%2C%20elegant%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=fermented-butter-01&orientation=landscape',
  'huang-you-su-mian-bao-hong-bei': 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20croissants%20with%20butter%20on%20marble%20surface%2C%20warm%20morning%20light%2C%20flaky%20pastry%20texture%2C%20elegant%20bakery%20aesthetic%2C%20minimal%20composition%2C%20soft%20natural%20lighting&width=800&height=520&seq=butter-croissant-01&orientation=landscape',
  'xiao-pi-liang-huang-you-sheng-chan': 'https://readdy.ai/api/search-image?query=Small%20batch%20artisan%20butter%20production%20in%20clean%20modern%20workshop%2C%20copper%20tools%2C%20cream%20texture%2C%20warm%20ambient%20lighting%2C%20minimal%20aesthetic%2C%20professional%20food%20photography&width=800&height=520&seq=small-batch-01&orientation=landscape',
  'fa-jiao-huang-you-shi-yan-ri-ji': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20fermentation%20experiment%20with%20glass%20jars%20and%20fresh%20cream%2C%20warm%20natural%20light%2C%20rustic%20wooden%20table%2C%20minimal%20composition%2C%20editorial%20food%20photography&width=800&height=520&seq=ferment-experiment-01&orientation=landscape',
  'da-xiang-cao-huang-you-shi-pu': 'https://readdy.ai/api/search-image?query=Artisan%20garlic%20herb%20compound%20butter%20on%20wooden%20board%20with%20fresh%20herbs%2C%20warm%20kitchen%20lighting%2C%20rustic%20texture%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=garlic-herb-butter-01&orientation=landscape',
  'gan-guo-mi-die-xiang-huang-you': 'https://readdy.ai/api/search-image?query=Artisan%20nut%20and%20honey%20butter%20on%20ceramic%20bowl%20with%20toast%2C%20warm%20morning%20light%2C%20cozy%20kitchen%20scene%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=nut-honey-butter-01&orientation=landscape',
  'huang-you-wen-du-kong-zhi-ji-qiao': 'https://readdy.ai/api/search-image?query=Softened%20butter%20on%20marble%20surface%20with%20baking%20tools%2C%20warm%20kitchen%20lighting%2C%20professional%20food%20photography%2C%20minimal%20composition%2C%20cream%20textures&width=800&height=520&seq=butter-temperature-01&orientation=landscape',
  'hai-yan-jiao-tang-huang-you': 'https://readdy.ai/api/search-image?query=Artisan%20salted%20caramel%20butter%20on%20ceramic%20dish%20with%20sea%20salt%20crystals%2C%20warm%20ambient%20lighting%2C%20rustic%20wooden%20surface%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=salted-caramel-butter-01&orientation=landscape',
  'you-ji-nai-you-xuan-gou-zhi-nan': 'https://readdy.ai/api/search-image?query=Organic%20fresh%20cream%20in%20glass%20bottle%20on%20farm%20table%2C%20pastoral%20setting%2C%20warm%20natural%20light%2C%20minimal%20composition%2C%20editorial%20food%20photography&width=800&height=520&seq=organic-cream-01&orientation=landscape',
  'kai-dian-zheng-jian-ban-li': 'https://readdy.ai/api/search-image?query=Clean%20modern%20artisan%20butter%20workshop%20space%20with%20professional%20equipment%2C%20warm%20lighting%2C%20organized%20workspace%2C%20minimal%20aesthetic%2C%20professional%20photography&width=800&height=520&seq=shop-guide-01&orientation=landscape',
  'song-lu-huang-you-zhi-zuo': 'https://readdy.ai/api/search-image?query=Artisan%20truffle%20butter%20on%20elegant%20ceramic%20plate%20with%20fresh%20truffle%2C%20dark%20moody%20lighting%2C%20luxury%20gourmet%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=truffle-butter-01&orientation=landscape',
  'fa-jiao-huang-you-yu-pu-tong-huang-you': 'https://readdy.ai/api/search-image?query=Two%20types%20of%20artisan%20butter%20side%20by%20side%20on%20rustic%20wooden%20board%2C%20warm%20natural%20light%2C%20minimal%20food%20comparison%20photography&width=800&height=520&seq=cultured-vs-regular-01&orientation=landscape',
  'bu-tong-guo-jia-huang-you-wen-hua': 'https://readdy.ai/api/search-image?query=World%20butter%20varieties%20on%20global%20map%20background%2C%20various%20artisan%20butters%20from%20different%20countries%2C%20warm%20lighting%2C%20editorial%20food%20photography&width=800&height=520&seq=world-butter-01&orientation=landscape',
  'lv-cha-bai-qiao-ke-li-huang-you': 'https://readdy.ai/api/search-image?query=Matcha%20green%20tea%20butter%20on%20ceramic%20plate%20with%20matcha%20powder%2C%20Japanese%20aesthetic%2C%20minimal%20composition%2C%20soft%20natural%20light%2C%20elegant%20food%20photography&width=800&height=520&seq=matcha-butter-01&orientation=landscape',
  'huang-you-ji-shu-ji-ben-gong': 'https://readdy.ai/api/search-image?query=Butter%20creaming%20process%20in%20mixing%20bowl%20with%20baking%20ingredients%2C%20warm%20kitchen%20lighting%2C%20minimal%20composition%2C%20professional%20food%20photography&width=800&height=520&seq=butter-creaming-01&orientation=landscape',
  'pin-pai-gu-shi-yu-ding-wei': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20brand%20packaging%20design%20on%20wooden%20table%2C%20elegant%20branding%2C%20warm%20lighting%2C%20minimal%20composition%2C%20professional%20product%20photography&width=800&height=520&seq=brand-story-01&orientation=landscape',
  'mei-ti-yun-ying-yu-nei-rong-ying-xiao': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20social%20media%20content%20creation%20scene%20with%20camera%20and%20props%2C%20warm%20lighting%2C%20minimal%20composition%2C%20professional%20photography&width=800&height=520&seq=social-media-01&orientation=landscape',
  'shou-gong-huang-you-chang-jian-wen-ti': 'https://readdy.ai/api/search-image?query=Artisan%20butter%20making%20process%20step%20by%20step%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20educational%20food%20photography%2C%20minimal%20composition&width=800&height=520&seq=butter-faq-01&orientation=landscape',
  'huang-you-qu-qi-bing-gan-pei-fang': 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20butter%20cookies%20on%20cooling%20rack%2C%20warm%20kitchen%20lighting%2C%20minimal%20composition%2C%20elegant%20food%20photography&width=800&height=520&seq=butter-cookies-01&orientation=landscape',
};

export default function Article() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <main>
        <Navbar />
        <div className="pt-16 md:pt-18">
          <div className="container-site py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">文章未找到</h1>
            <p className="text-foreground-600 mb-6">抱歉，您要查看的文章不存在或已被移除。</p>
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors cursor-pointer">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </main>
    );
  }

  const category = categories.find((c) => c.slug === article.category);
  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.slug !== article.slug)
    .slice(0, 3);

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://huangyouzuofang.com/' },
      { '@type': 'ListItem', position: 2, name: category?.name || '', item: `https://huangyouzuofang.com/category/${article.category}` },
      { '@type': 'ListItem', position: 3, name: article.title, item: `https://huangyouzuofang.com/article/${article.slug}` },
    ],
  };

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: { '@type': 'Person', name: article.author },
    datePublished: article.date,
    publisher: {
      '@type': 'Organization',
      name: '黄油作坊',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <main>
        <Navbar />
        <article className="pt-16 md:pt-18">
          <div className="bg-background-100">
            <div className="container-site py-8 md:py-12">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-5 flex-wrap" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <Link to={`/category/${article.category}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {category?.name || article.category}
                </Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-800 font-medium line-clamp-1">{article.title}</span>
              </nav>
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
                {article.title}
              </h1>
              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  {article.readTime}
                </span>
                {category && (
                  <Link
                    to={`/category/${article.category}`}
                    className="flex items-center gap-1.5 text-primary-600 hover:text-primary-700 cursor-pointer"
                  >
                    <i className="ri-folder-line"></i>
                    {category.name}
                  </Link>
                )}
              </div>
            </div>
          </div>

          <div className="container-site py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              {articleImages[article.slug] && (
                <div className="relative w-full h-64 md:h-96 rounded-2xl overflow-hidden mb-10">
                  <img
                    src={articleImages[article.slug]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              )}

              <div
                className="prose max-w-none
                  prose-headings:font-heading prose-headings:text-foreground-900 prose-headings:font-bold
                  prose-h2:text-xl md:prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-4
                  prose-h3:text-lg md:prose-h3:text-xl prose-h3:mt-8 prose-h3:mb-3
                  prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:mb-5 prose-p:text-base md:prose-p:text-lg
                  prose-ul:text-foreground-700 prose-ul:leading-relaxed prose-ul:mb-5
                  prose-li:mb-2 prose-li:text-base md:prose-li:text-lg
                  prose-strong:text-foreground-900 prose-strong:font-semibold
                  [&_p]:text-base [&_p]:md:text-lg [&_p]:text-foreground-700 [&_p]:leading-relaxed [&_p]:mb-5
                  [&_h2]:font-heading [&_h2]:text-xl [&_h2]:md:text-2xl [&_h2]:font-bold [&_h2]:text-foreground-900 [&_h2]:mt-10 [&_h2]:mb-4
                  [&_h3]:font-heading [&_h3]:text-lg [&_h3]:md:text-xl [&_h3]:font-semibold [&_h3]:text-foreground-900 [&_h3]:mt-8 [&_h3]:mb-3
                  [&_ul]:text-foreground-700 [&_ul]:leading-relaxed [&_ul]:mb-5 [&_ul]:list-disc [&_ul]:pl-6
                  [&_li]:mb-2 [&_li]:text-base [&_li]:md:text-lg
                  [&_strong]:text-foreground-900 [&_strong]:font-semibold"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              <div className="mt-10 pt-8 border-t border-background-200/60">
                <div className="flex flex-wrap gap-2">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-100 rounded-full"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-8 flex items-center gap-3">
                <span className="text-sm text-foreground-500">分享到：</span>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="分享到微信">
                  <i className="ri-wechat-fill"></i>
                </button>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="分享到微博">
                  <i className="ri-weibo-fill"></i>
                </button>
                <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="复制链接">
                  <i className="ri-link"></i>
                </button>
              </div>
            </div>
          </div>

          {relatedArticles.length > 0 && (
            <div className="bg-background-100 py-14 md:py-18">
              <div className="container-site">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8 text-center">
                  相关文章
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {relatedArticles.map((ra, index) => (
                    <Link
                      key={ra.slug}
                      to={`/article/${ra.slug}`}
                      className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                    >
                      <div className="relative h-44 overflow-hidden">
                        <img
                          src={articleImages[ra.slug] || articleImages['shougong-huangyou-ru-men-zhi-nan']}
                          alt={ra.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          loading={index > 0 ? 'lazy' : undefined}
                        />
                      </div>
                      <div className="p-4">
                        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                          <span>{ra.date}</span>
                          <span>{ra.readTime}</span>
                        </div>
                        <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                          {ra.title}
                        </h3>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </article>
        <Footer />
      </main>
    </>
  );
}